import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
    components: {

    },
})
export default class Pay extends Vue {
  private $api: any;
  private amount: string = '';      // 金额
  private position: any = '';    // 当前支付地点ID
  private positionName: any = '';  // 当前支付地点名
  private canPay: boolean = false;  // 是否可以充值
  private notEnough: boolean = false; // 余额是否不足
  private isPaying: boolean = false;  // 是否正在调用支付接口
  private isGettingPayKey: boolean = true; // 是否正在获取密钥中
  private payKey: string = '';       // 当前支付接口的密钥
  private userId: string = '';            // 充值用户的ID
  private userInfo: string = '';          // 充值用户的信息
  private canRechargeDialog: boolean = false; // 额度已达上限的提示对话框
  private isGettingRechargeStatus: boolean = false; // 正在获取充值额度状态 

  // life cycle
  private mounted() {
    this.getPosition();
    this.getKey();
  }

  // 获取地址和图标
  private getPosition() {
    // 得到当前url中的参数
    const position = JSON.parse(localStorage.getItem('THIS_LOCATION_HREF_QUERY') || '').position;
    const positionName = JSON.parse(localStorage.getItem('THIS_LOCATION_HREF_QUERY') || '').positionName;
    // 判断地点是否为空
    if (position !== '' && positionName !== '') {
      // 记录地点
      this.position = position;
      this.positionName = positionName;

    }
    // 获取图标 (暂时不需要)
    // const avatar = urlParams.get('avatar');
  } 

  @Watch('amount')
  private onAmountChanged(val: string, oldVal: string) {
    this.canPay = false;
    const rule = /^\d+(\.\d{0,2})?$/;
    // 只能输入数字
    if (!rule.test(val) && val !== '') {
      this.amount = oldVal;
    } else {
      // 如果值不为空
      if (val !== '') {
        const amount = parseFloat(val);
        // 如果输入的是 0
        if (amount === 0) {
          // console.log(amount);
          // this.amount = '';
        } else {
            this.canPay = true;
        }
      }
    }
  }

  // 第一次握手，得到充值接口可用的密钥
  private async getKey() {
    this.isGettingPayKey = true;
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/GiveKey');
    if (result.Success) {
      // console.log(result.Data);
      // 记录返回的密钥
      this.payKey = result.Data.Key;
      this.userId = result.Data.UserBaseInfoId;
      this.userInfo = result.Data.RechargeAccount;
      this.isGettingPayKey = false;
    } else {
        this.$notify(result.AllMessages);
    }
  }

  // 付款按钮
  private async pay() {
    this.isPaying = true;
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在付款...',
    });
    const params = {
      key: this.payKey,
      userBaseInfoId: this.userId,
      amount: parseFloat(this.amount),
      position: this.position,
      positionName: this.positionName,
    };
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/WeChatSupermarketConsumption', params);
    if (result.Success) {
      this.$store.commit('paySucceed', { status: true, amount: this.amount });  // 记录充值成功状态
      this.$router.push('/pay-success');
    } else {
      // 暂时是从后台传来的错误信息判断的，应该有更好的方式
      if (result.AllMessages === '余额不足') {
        this.notEnough = true;
      } else {
        this.$notify(result.AllMessages);
      }
      this.getKey();
    }
    this.isPaying = false;
    this.$toast.clear();
  }

  // 去充值
  private async toRecharge() {
    if (this.isGettingRechargeStatus) {
      return;
    }
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在验证可用额度...',
    });
    this.isGettingRechargeStatus = true;
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/JudgeRechargeButton');
    if (result.Success) {
      if (result.Data) {
        // 如果可以充值
        this.$router.push('/recharge');
      } else {
        // 如果充值额度已用完
        this.canRechargeDialog = true;
      }
    } else {
      this.$notify(result.AllMessages);
    }
    this.isGettingRechargeStatus = false;
    this.$toast.clear();
  }



}
